import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { SearchOutlined } from '@ant-design/icons-vue';
export default {
  __name: 'xSearchButton',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createBlock(_component_a_button, _normalizeProps(_guardReactiveProps(_ctx.$attrs)), {
        icon: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_cache[0] || (_cache[0] = _createTextVNode(" 搜索 ", -1))])]),
        _: 3
      }, 16);
    };
  }
};